export const GET_LIST_DANHSACHNHANVIEN = "GET_LIST_DANHSACHNHANVIEN";
export const GET_LIST_DANHSACHNHANVIEN_SUCCESS =
  "GET_LIST_DANHSACHNHANVIEN_SUCCESS";
export const GET_LIST_DANHSACHNHANVIEN_FAILURE =
  "GET_LIST_DANHSACHNHANVIEN_FAILURE";
